var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[_c('a-checkbox-group',{on:{"change":_vm.onChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm._l((_vm.checkboxArray),function(item){return _c('a-checkbox',{key:item.key,attrs:{"value":item.key}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }